import { render, staticRenderFns } from "./PostAddMedia.vue?vue&type=template&id=2197fd0f&scoped=true&"
import script from "./PostAddMedia.vue?vue&type=script&lang=js&"
export * from "./PostAddMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197fd0f",
  null
  
)

export default component.exports